import { createClient } from '@linabase/js';

const url = import.meta.env.VITE_LINABASE_URL;
const anonKey = import.meta.env.VITE_LINABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error('Missing VITE_LINABASE_URL or VITE_LINABASE_ANON_KEY');
}

export const linabase = createClient({
  url,
  anonKey,
  auth: {
    persistSession: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'hooklink.session',
    // SDK auto-consumes #access_token=... from OAuth / magic-link callbacks.
    detectSessionInUrl: true,
  },
});
